module.exports = __webpack_public_path__ + "img/Antonia&Stephan-15.d577c264.jpg";